// @ts-ignore
import Navigation from 'vue-navigation'
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import VueRouter, { RouteConfig } from 'vue-router'
import { createUrlQueryString, mapValues } from 'vtils'
import { currentChannelId } from '@/channel'
import { dcb } from '@dcb/jssdk'
import { globalModel } from '@/model'
import { wechat } from '@/wechat'

Vue.use(VueRouter)
Vue.use(VueCompositionAPI)

function patchPage(Component: any) {
  return Component.default || Component
}

export const pageNameMap = {
  // @index(['../views/**/*.vue', '!**/{components,blocks}/**'], (f, _) => `${_.pascal(f.path.replace('../views/', '/'))}: '${_.pascal(f.path.replace('../views/', '/'))}',`)
  Activity_2022MayConsumerCouponIndex: 'Activity_2022MayConsumerCouponIndex',
  Activity_2022QixiFestivalIndex: 'Activity_2022QixiFestivalIndex',
  Activity_2022SummerDriftIndex: 'Activity_2022SummerDriftIndex',
  Activity_2022WomenDayIndex: 'Activity_2022WomenDayIndex',
  Activity_2023LaozihaoJianianhua: 'Activity_2023LaozihaoJianianhua',
  Activity_2025NewYearIndex: 'Activity_2025NewYearIndex',
  Activity_2025NewYearTheme: 'Activity_2025NewYearTheme',
  ActivityIndex: 'ActivityIndex',
  AddressCoord: 'AddressCoord',
  AddressEdit: 'AddressEdit',
  AddressIndex: 'AddressIndex',
  AdminActivityMaker: 'AdminActivityMaker',
  AdminUrlMaker: 'AdminUrlMaker',
  AfterSalesDetail: 'AfterSalesDetail',
  AfterSalesHistory: 'AfterSalesHistory',
  AfterSalesIndex: 'AfterSalesIndex',
  AfterSalesRequestLayout: 'AfterSalesRequestLayout',
  AfterSalesRequestChoose: 'AfterSalesRequestChoose',
  AfterSalesRequestSubmit: 'AfterSalesRequestSubmit',
  BookCommentAdd: 'BookCommentAdd',
  BookCommentDetail: 'BookCommentDetail',
  BookCommentIndex: 'BookCommentIndex',
  BookGoodsIndex: 'BookGoodsIndex',
  BookIndex: 'BookIndex',
  BookMartAvailable: 'BookMartAvailable',
  BookMartUse: 'BookMartUse',
  BookOrderDetail: 'BookOrderDetail',
  BookOrderIndex: 'BookOrderIndex',
  BookOrderPlace: 'BookOrderPlace',
  BookRefundRequest: 'BookRefundRequest',
  BookRefundResult: 'BookRefundResult',
  BookVerifyConfirm: 'BookVerifyConfirm',
  BookVerifyDetail: 'BookVerifyDetail',
  BookVerifyIndex: 'BookVerifyIndex',
  BookVerifyMart: 'BookVerifyMart',
  BookVerifyResult: 'BookVerifyResult',
  BoxDelivery: 'BoxDelivery',
  BoxDetail_2025: 'BoxDetail_2025',
  BoxDetail: 'BoxDetail',
  BoxIndex_2025: 'BoxIndex_2025',
  BoxIndexOld: 'BoxIndexOld',
  BoxIndex: 'BoxIndex',
  BoxOpen_2025: 'BoxOpen_2025',
  BoxOpenOld: 'BoxOpenOld',
  BoxOpenRecord: 'BoxOpenRecord',
  BoxOpen: 'BoxOpen',
  BoxOrderList: 'BoxOrderList',
  BoxRefundResult: 'BoxRefundResult',
  BoxRule_2025: 'BoxRule_2025',
  BoxRule: 'BoxRule',
  BridgeIndex: 'BridgeIndex',
  BridgeWxpayCallback: 'BridgeWxpayCallback',
  BridgeWxpay: 'BridgeWxpay',
  CartIndex: 'CartIndex',
  CategoryIndex: 'CategoryIndex',
  CommentIndex: 'CommentIndex',
  CommentList: 'CommentList',
  CommonReload: 'CommonReload',
  DiyFixedQhcs: 'DiyFixedQhcs',
  DiyListIndex: 'DiyListIndex',
  DiyMartIndex: 'DiyMartIndex',
  DiyPageIndex: 'DiyPageIndex',
  DiySearchIndex: 'DiySearchIndex',
  DiyTest: 'DiyTest',
  DkyCart: 'DkyCart',
  DkyIndex: 'DkyIndex',
  DkyRxbd: 'DkyRxbd',
  DkyTjsp: 'DkyTjsp',
  DkyUser: 'DkyUser',
  DkyXsth: 'DkyXsth',
  DkyZxkt: 'DkyZxkt',
  ExchangeIndex: 'ExchangeIndex',
  ExchangeInfo: 'ExchangeInfo',
  ExchangeStore: 'ExchangeStore',
  ExpressIndex: 'ExpressIndex',
  ExpressPackages: 'ExpressPackages',
  GoodsIndex: 'GoodsIndex',
  Goods1Index: 'Goods1Index',
  GroupBuyingIndex: 'GroupBuyingIndex',
  GroupBuyingInvite: 'GroupBuyingInvite',
  GroupBuyingOrderDetail: 'GroupBuyingOrderDetail',
  GroupBuyingOrderIndex: 'GroupBuyingOrderIndex',
  GroupBuyingPaySuccess: 'GroupBuyingPaySuccess',
  HomeIndex: 'HomeIndex',
  InstantDeliveryGoodsIndex: 'InstantDeliveryGoodsIndex',
  InstantDeliveryIndex: 'InstantDeliveryIndex',
  InstantDeliveryMartDetail: 'InstantDeliveryMartDetail',
  InstantDeliveryMartIndex: 'InstantDeliveryMartIndex',
  InstantDeliveryMartList: 'InstantDeliveryMartList',
  InstantDeliveryOrderDetail: 'InstantDeliveryOrderDetail',
  InstantDeliveryOrderIndex: 'InstantDeliveryOrderIndex',
  InstantDeliveryOrderPlace: 'InstantDeliveryOrderPlace',
  InstantDeliveryOrderSuccess: 'InstantDeliveryOrderSuccess',
  InvoiceDetail: 'InvoiceDetail',
  InvoiceRequest: 'InvoiceRequest',
  JointStdGoodsIndex: 'JointStdGoodsIndex',
  JointStdOrderCancelResult: 'JointStdOrderCancelResult',
  JointStdOrderComment: 'JointStdOrderComment',
  JointStdOrderConfirmResult: 'JointStdOrderConfirmResult',
  JointStdOrderDetail: 'JointStdOrderDetail',
  JointStdOrderIndex: 'JointStdOrderIndex',
  JointStdOrderPayResult: 'JointStdOrderPayResult',
  JointStdOrderPlace: 'JointStdOrderPlace',
  JointGoodsIndex: 'JointGoodsIndex',
  JointOrderPlace: 'JointOrderPlace',
  JointOrderSuccess: 'JointOrderSuccess',
  ManageAfterSales: 'ManageAfterSales',
  ManageBasicsetIndex: 'ManageBasicsetIndex',
  ManageDeliverypersonAdd: 'ManageDeliverypersonAdd',
  ManageDeliverypersonIndex: 'ManageDeliverypersonIndex',
  ManageIndex: 'ManageIndex',
  ManageOrderdeliveryAgreeRefundSheet: 'ManageOrderdeliveryAgreeRefundSheet',
  ManageOrderdeliveryIndex: 'ManageOrderdeliveryIndex',
  ManageOrderdeliveryOrderDetail: 'ManageOrderdeliveryOrderDetail',
  ManageOrderdeliveryOrderItem: 'ManageOrderdeliveryOrderItem',
  ManageOrderItem: 'ManageOrderItem',
  MartCert: 'MartCert',
  MartClassifiedGoods: 'MartClassifiedGoods',
  MartIndex: 'MartIndex',
  MartPhoto: 'MartPhoto',
  MartSearch: 'MartSearch',
  OrderCancelResult: 'OrderCancelResult',
  OrderCenter: 'OrderCenter',
  OrderChangeAddress: 'OrderChangeAddress',
  OrderComment: 'OrderComment',
  OrderConfirmResult: 'OrderConfirmResult',
  OrderDetail: 'OrderDetail',
  OrderExchangeResult: 'OrderExchangeResult',
  OrderIndex: 'OrderIndex',
  OrderPayError: 'OrderPayError',
  OrderPayResult: 'OrderPayResult',
  OrderPlace: 'OrderPlace',
  OrderPlace1: 'OrderPlace1',
  OrderQsxfjPayResult: 'OrderQsxfjPayResult',
  PayIndex: 'PayIndex',
  SafeKeyboardTestIndex: 'SafeKeyboardTestIndex',
  SearchEntry: 'SearchEntry',
  SearchIndex: 'SearchIndex',
  SeckillIndex: 'SeckillIndex',
  SlhCategory: 'SlhCategory',
  SlhSearch: 'SlhSearch',
  StationPick: 'StationPick',
  StrategyIndex: 'StrategyIndex',
  Template: 'Template',
  Template2: 'Template2',
  TestSafe: 'TestSafe',
  TopicIndex: 'TopicIndex',
  TopicTop: 'TopicTop',
  TravelCommentAdd: 'TravelCommentAdd',
  TravelCommentDetail: 'TravelCommentDetail',
  TravelCommentIndex: 'TravelCommentIndex',
  TravelGoodsIndex: 'TravelGoodsIndex',
  TravelIndex: 'TravelIndex',
  TravelOrderDetail: 'TravelOrderDetail',
  TravelOrderIndex: 'TravelOrderIndex',
  TravelOrderPlace: 'TravelOrderPlace',
  TravelOrderPlace1: 'TravelOrderPlace1',
  TravelRefundRequest: 'TravelRefundRequest',
  TravelRefundResult: 'TravelRefundResult',
  TravelVerifyConfirm: 'TravelVerifyConfirm',
  TravelVerifyDetail: 'TravelVerifyDetail',
  TravelVerifyIndex: 'TravelVerifyIndex',
  TravelVerifyMart: 'TravelVerifyMart',
  TravelVerifyResult: 'TravelVerifyResult',
  TvAfterSalesRequest: 'TvAfterSalesRequest',
  TvBookGoodsExplain: 'TvBookGoodsExplain',
  TvBookGoodsIndex: 'TvBookGoodsIndex',
  TvBookGoodsResult: 'TvBookGoodsResult',
  TvBookIndex: 'TvBookIndex',
  TvBookOrderDetail: 'TvBookOrderDetail',
  TvBookOrderIndex: 'TvBookOrderIndex',
  TvBookOrderResult: 'TvBookOrderResult',
  TvCartIndex: 'TvCartIndex',
  TvGoodsIndex: 'TvGoodsIndex',
  TvHomeIndex: 'TvHomeIndex',
  TvMartIndex: 'TvMartIndex',
  TvOrderDetail: 'TvOrderDetail',
  TvOrderIndex: 'TvOrderIndex',
  TvOrderPlace: 'TvOrderPlace',
  TvSearchIndex: 'TvSearchIndex',
  TvSeckillIndex: 'TvSeckillIndex',
  TvTemplateClass: 'TvTemplateClass',
  TvTemplate: 'TvTemplate',
  TvTopicIndex: 'TvTopicIndex',
  TvUserFavorite: 'TvUserFavorite',
  UserComment: 'UserComment',
  UserFavorite: 'UserFavorite',
  UserHistory: 'UserHistory',
  UserIndex: 'UserIndex',
  UserProtocol: 'UserProtocol',
  // @endindex
}

export const pagePathMap = {
  // @index(['../views/**/*.vue', '!**/{components,blocks}/**'], (f, _) => `${_.pascal(f.path.replace('../views/', '/'))}: '${f.path.replace('../views/', '/').replace(/\[(.*?)\]/g, ':$1')}',`)
  Activity_2022MayConsumerCouponIndex:
    '/activity/2022/may_consumer_coupon/index',
  Activity_2022QixiFestivalIndex: '/activity/2022/qixi_festival/index',
  Activity_2022SummerDriftIndex: '/activity/2022/summer_drift/index',
  Activity_2022WomenDayIndex: '/activity/2022/women_day/index',
  Activity_2023LaozihaoJianianhua: '/activity/2023/laozihao/jianianhua',
  Activity_2025NewYearIndex: '/activity/2025/new_year/index',
  Activity_2025NewYearTheme: '/activity/2025/new_year/theme',
  ActivityIndex: '/activity/index',
  AddressCoord: '/address/coord',
  AddressEdit: '/address/edit',
  AddressIndex: '/address/index',
  AdminActivityMaker: '/admin/activity_maker',
  AdminUrlMaker: '/admin/url_maker',
  AfterSalesDetail: '/after_sales/detail',
  AfterSalesHistory: '/after_sales/history',
  AfterSalesIndex: '/after_sales/index',
  AfterSalesRequestLayout: '/after_sales/request/_layout',
  AfterSalesRequestChoose: '/after_sales/request/choose',
  AfterSalesRequestSubmit: '/after_sales/request/submit',
  BookCommentAdd: '/book/comment/add',
  BookCommentDetail: '/book/comment/detail',
  BookCommentIndex: '/book/comment/index',
  BookGoodsIndex: '/book/goods/index',
  BookIndex: '/book/index',
  BookMartAvailable: '/book/mart/available',
  BookMartUse: '/book/mart/use',
  BookOrderDetail: '/book/order/detail',
  BookOrderIndex: '/book/order/index',
  BookOrderPlace: '/book/order/place',
  BookRefundRequest: '/book/refund/request',
  BookRefundResult: '/book/refund/result',
  BookVerifyConfirm: '/book/verify/confirm',
  BookVerifyDetail: '/book/verify/detail',
  BookVerifyIndex: '/book/verify/index',
  BookVerifyMart: '/book/verify/mart',
  BookVerifyResult: '/book/verify/result',
  BoxDelivery: '/box/delivery',
  BoxDetail_2025: '/box/detail_2025',
  BoxDetail: '/box/detail',
  BoxIndex_2025: '/box/index_2025',
  BoxIndexOld: '/box/index_old',
  BoxIndex: '/box/index',
  BoxOpen_2025: '/box/open_2025',
  BoxOpenOld: '/box/open_old',
  BoxOpenRecord: '/box/open_record',
  BoxOpen: '/box/open',
  BoxOrderList: '/box/order_list',
  BoxRefundResult: '/box/refund_result',
  BoxRule_2025: '/box/rule_2025',
  BoxRule: '/box/rule',
  BridgeIndex: '/bridge/index',
  BridgeWxpayCallback: '/bridge/wxpay_callback',
  BridgeWxpay: '/bridge/wxpay',
  CartIndex: '/cart/index',
  CategoryIndex: '/category/index',
  CommentIndex: '/comment/index',
  CommentList: '/comment/list',
  CommonReload: '/common/reload',
  DiyFixedQhcs: '/diy/fixed/qhcs',
  DiyListIndex: '/diy/list/index',
  DiyMartIndex: '/diy/mart/index',
  DiyPageIndex: '/diy/page/index',
  DiySearchIndex: '/diy/search/index',
  DiyTest: '/diy/test',
  DkyCart: '/dky/cart',
  DkyIndex: '/dky/index',
  DkyRxbd: '/dky/rxbd',
  DkyTjsp: '/dky/tjsp',
  DkyUser: '/dky/user',
  DkyXsth: '/dky/xsth',
  DkyZxkt: '/dky/zxkt',
  ExchangeIndex: '/exchange/index',
  ExchangeInfo: '/exchange/info',
  ExchangeStore: '/exchange/store',
  ExpressIndex: '/express/index',
  ExpressPackages: '/express/packages',
  GoodsIndex: '/goods/index',
  Goods1Index: '/goods1/index',
  GroupBuyingIndex: '/group_buying/index',
  GroupBuyingInvite: '/group_buying/invite',
  GroupBuyingOrderDetail: '/group_buying/order/detail',
  GroupBuyingOrderIndex: '/group_buying/order/index',
  GroupBuyingPaySuccess: '/group_buying/pay_success',
  HomeIndex: '/home/index',
  InstantDeliveryGoodsIndex: '/instant_delivery/goods/index',
  InstantDeliveryIndex: '/instant_delivery/index',
  InstantDeliveryMartDetail: '/instant_delivery/mart/detail',
  InstantDeliveryMartIndex: '/instant_delivery/mart/index',
  InstantDeliveryMartList: '/instant_delivery/mart/list',
  InstantDeliveryOrderDetail: '/instant_delivery/order/detail',
  InstantDeliveryOrderIndex: '/instant_delivery/order/index',
  InstantDeliveryOrderPlace: '/instant_delivery/order/place',
  InstantDeliveryOrderSuccess: '/instant_delivery/order/success',
  InvoiceDetail: '/invoice/detail',
  InvoiceRequest: '/invoice/request',
  JointStdGoodsIndex: '/joint_std/goods/index',
  JointStdOrderCancelResult: '/joint_std/order/cancel_result',
  JointStdOrderComment: '/joint_std/order/comment',
  JointStdOrderConfirmResult: '/joint_std/order/confirm_result',
  JointStdOrderDetail: '/joint_std/order/detail',
  JointStdOrderIndex: '/joint_std/order/index',
  JointStdOrderPayResult: '/joint_std/order/pay_result',
  JointStdOrderPlace: '/joint_std/order/place',
  JointGoodsIndex: '/joint/goods/index',
  JointOrderPlace: '/joint/order/place',
  JointOrderSuccess: '/joint/order/success',
  ManageAfterSales: '/manage/afterSales',
  ManageBasicsetIndex: '/manage/basicset/index',
  ManageDeliverypersonAdd: '/manage/deliveryperson/add',
  ManageDeliverypersonIndex: '/manage/deliveryperson/index',
  ManageIndex: '/manage/index',
  ManageOrderdeliveryAgreeRefundSheet: '/manage/orderdelivery/agreeRefundSheet',
  ManageOrderdeliveryIndex: '/manage/orderdelivery/index',
  ManageOrderdeliveryOrderDetail: '/manage/orderdelivery/orderDetail',
  ManageOrderdeliveryOrderItem: '/manage/orderdelivery/orderItem',
  ManageOrderItem: '/manage/orderItem',
  MartCert: '/mart/cert',
  MartClassifiedGoods: '/mart/classified_goods',
  MartIndex: '/mart/index',
  MartPhoto: '/mart/photo',
  MartSearch: '/mart/search',
  OrderCancelResult: '/order/cancel_result',
  OrderCenter: '/order/center',
  OrderChangeAddress: '/order/change_address',
  OrderComment: '/order/comment',
  OrderConfirmResult: '/order/confirm_result',
  OrderDetail: '/order/detail',
  OrderExchangeResult: '/order/exchange_result',
  OrderIndex: '/order/index',
  OrderPayError: '/order/pay_error',
  OrderPayResult: '/order/pay_result',
  OrderPlace: '/order/place',
  OrderPlace1: '/order/place1',
  OrderQsxfjPayResult: '/order/qsxfj_pay_result',
  PayIndex: '/pay/index',
  SafeKeyboardTestIndex: '/safe_keyboard_test/index',
  SearchEntry: '/search/entry',
  SearchIndex: '/search/index',
  SeckillIndex: '/seckill/index',
  SlhCategory: '/slh/category',
  SlhSearch: '/slh/search',
  StationPick: '/station/pick',
  StrategyIndex: '/strategy/index',
  Template: '/template',
  Template2: '/template2',
  TestSafe: '/test/safe',
  TopicIndex: '/topic/index',
  TopicTop: '/topic/top',
  TravelCommentAdd: '/travel/comment/add',
  TravelCommentDetail: '/travel/comment/detail',
  TravelCommentIndex: '/travel/comment/index',
  TravelGoodsIndex: '/travel/goods/index',
  TravelIndex: '/travel/index',
  TravelOrderDetail: '/travel/order/detail',
  TravelOrderIndex: '/travel/order/index',
  TravelOrderPlace: '/travel/order/place',
  TravelOrderPlace1: '/travel/order/place1',
  TravelRefundRequest: '/travel/refund/request',
  TravelRefundResult: '/travel/refund/result',
  TravelVerifyConfirm: '/travel/verify/confirm',
  TravelVerifyDetail: '/travel/verify/detail',
  TravelVerifyIndex: '/travel/verify/index',
  TravelVerifyMart: '/travel/verify/mart',
  TravelVerifyResult: '/travel/verify/result',
  TvAfterSalesRequest: '/tv/after_sales/request',
  TvBookGoodsExplain: '/tv/book/goods/explain',
  TvBookGoodsIndex: '/tv/book/goods/index',
  TvBookGoodsResult: '/tv/book/goods/result',
  TvBookIndex: '/tv/book/index',
  TvBookOrderDetail: '/tv/book/order/detail',
  TvBookOrderIndex: '/tv/book/order/index',
  TvBookOrderResult: '/tv/book/order/result',
  TvCartIndex: '/tv/cart/index',
  TvGoodsIndex: '/tv/goods/index',
  TvHomeIndex: '/tv/home/index',
  TvMartIndex: '/tv/mart/index',
  TvOrderDetail: '/tv/order/detail',
  TvOrderIndex: '/tv/order/index',
  TvOrderPlace: '/tv/order/place',
  TvSearchIndex: '/tv/search/index',
  TvSeckillIndex: '/tv/seckill/index',
  TvTemplateClass: '/tv/template_class',
  TvTemplate: '/tv/template',
  TvTopicIndex: '/tv/topic/index',
  TvUserFavorite: '/tv/user/favorite',
  UserComment: '/user/comment',
  UserFavorite: '/user/favorite',
  UserHistory: '/user/history',
  UserIndex: '/user/index',
  UserProtocol: '/user/protocol',
  // @endindex
}

let routes: Array<RouteConfig> = [
  // @index(['../views/**/*.vue', '!**/{components,blocks}/**'], (f, _) => `{ path: '${f.path.replace('../views/', '/').replace(/\[(.*?)\]/g, ':$1')}', name: '${_.pascal(f.path.replace('../views/', '/'))}', component: patchPage(require('${f.path}${f.ext}'))},`)
  {
    path: '/activity/2022/may_consumer_coupon/index',
    name: 'Activity_2022MayConsumerCouponIndex',
    component: patchPage(
      require('../views/activity/2022/may_consumer_coupon/index.vue'),
    ),
  },
  {
    path: '/activity/2022/qixi_festival/index',
    name: 'Activity_2022QixiFestivalIndex',
    component: patchPage(
      require('../views/activity/2022/qixi_festival/index.vue'),
    ),
  },
  {
    path: '/activity/2022/summer_drift/index',
    name: 'Activity_2022SummerDriftIndex',
    component: patchPage(
      require('../views/activity/2022/summer_drift/index.vue'),
    ),
  },
  {
    path: '/activity/2022/women_day/index',
    name: 'Activity_2022WomenDayIndex',
    component: patchPage(require('../views/activity/2022/women_day/index.vue')),
  },
  {
    path: '/activity/2023/laozihao/jianianhua',
    name: 'Activity_2023LaozihaoJianianhua',
    component: patchPage(
      require('../views/activity/2023/laozihao/jianianhua.vue'),
    ),
  },
  {
    path: '/activity/2025/new_year/index',
    name: 'Activity_2025NewYearIndex',
    component: patchPage(require('../views/activity/2025/new_year/index.vue')),
  },
  {
    path: '/activity/2025/new_year/theme',
    name: 'Activity_2025NewYearTheme',
    component: patchPage(require('../views/activity/2025/new_year/theme.vue')),
  },
  {
    path: '/activity/index',
    name: 'ActivityIndex',
    component: patchPage(require('../views/activity/index.vue')),
  },
  {
    path: '/address/coord',
    name: 'AddressCoord',
    component: patchPage(require('../views/address/coord.vue')),
  },
  {
    path: '/address/edit',
    name: 'AddressEdit',
    component: patchPage(require('../views/address/edit.vue')),
  },
  {
    path: '/address/index',
    name: 'AddressIndex',
    component: patchPage(require('../views/address/index.vue')),
  },
  {
    path: '/admin/activity_maker',
    name: 'AdminActivityMaker',
    component: patchPage(require('../views/admin/activity_maker.vue')),
  },
  {
    path: '/admin/url_maker',
    name: 'AdminUrlMaker',
    component: patchPage(require('../views/admin/url_maker.vue')),
  },
  {
    path: '/after_sales/detail',
    name: 'AfterSalesDetail',
    component: patchPage(require('../views/after_sales/detail.vue')),
  },
  {
    path: '/after_sales/history',
    name: 'AfterSalesHistory',
    component: patchPage(require('../views/after_sales/history.vue')),
  },
  {
    path: '/after_sales/index',
    name: 'AfterSalesIndex',
    component: patchPage(require('../views/after_sales/index.vue')),
  },
  {
    path: '/after_sales/request/_layout',
    name: 'AfterSalesRequestLayout',
    component: patchPage(require('../views/after_sales/request/_layout.vue')),
  },
  {
    path: '/after_sales/request/choose',
    name: 'AfterSalesRequestChoose',
    component: patchPage(require('../views/after_sales/request/choose.vue')),
  },
  {
    path: '/after_sales/request/submit',
    name: 'AfterSalesRequestSubmit',
    component: patchPage(require('../views/after_sales/request/submit.vue')),
  },
  {
    path: '/book/comment/add',
    name: 'BookCommentAdd',
    component: patchPage(require('../views/book/comment/add.vue')),
  },
  {
    path: '/book/comment/detail',
    name: 'BookCommentDetail',
    component: patchPage(require('../views/book/comment/detail.vue')),
  },
  {
    path: '/book/comment/index',
    name: 'BookCommentIndex',
    component: patchPage(require('../views/book/comment/index.vue')),
  },
  {
    path: '/book/goods/index',
    name: 'BookGoodsIndex',
    component: patchPage(require('../views/book/goods/index.vue')),
  },
  {
    path: '/book/index',
    name: 'BookIndex',
    component: patchPage(require('../views/book/index.vue')),
  },
  {
    path: '/book/mart/available',
    name: 'BookMartAvailable',
    component: patchPage(require('../views/book/mart/available.vue')),
  },
  {
    path: '/book/mart/use',
    name: 'BookMartUse',
    component: patchPage(require('../views/book/mart/use.vue')),
  },
  {
    path: '/book/order/detail',
    name: 'BookOrderDetail',
    component: patchPage(require('../views/book/order/detail.vue')),
  },
  {
    path: '/book/order/index',
    name: 'BookOrderIndex',
    component: patchPage(require('../views/book/order/index.vue')),
  },
  {
    path: '/book/order/place',
    name: 'BookOrderPlace',
    component: patchPage(require('../views/book/order/place.vue')),
  },
  {
    path: '/book/refund/request',
    name: 'BookRefundRequest',
    component: patchPage(require('../views/book/refund/request.vue')),
  },
  {
    path: '/book/refund/result',
    name: 'BookRefundResult',
    component: patchPage(require('../views/book/refund/result.vue')),
  },
  {
    path: '/book/verify/confirm',
    name: 'BookVerifyConfirm',
    component: patchPage(require('../views/book/verify/confirm.vue')),
  },
  {
    path: '/book/verify/detail',
    name: 'BookVerifyDetail',
    component: patchPage(require('../views/book/verify/detail.vue')),
  },
  {
    path: '/book/verify/index',
    name: 'BookVerifyIndex',
    component: patchPage(require('../views/book/verify/index.vue')),
  },
  {
    path: '/book/verify/mart',
    name: 'BookVerifyMart',
    component: patchPage(require('../views/book/verify/mart.vue')),
  },
  {
    path: '/book/verify/result',
    name: 'BookVerifyResult',
    component: patchPage(require('../views/book/verify/result.vue')),
  },
  {
    path: '/box/delivery',
    name: 'BoxDelivery',
    component: patchPage(require('../views/box/delivery.vue')),
  },
  {
    path: '/box/detail_2025',
    name: 'BoxDetail_2025',
    component: patchPage(require('../views/box/detail_2025.vue')),
  },
  {
    path: '/box/detail',
    name: 'BoxDetail',
    component: patchPage(require('../views/box/detail.vue')),
  },
  {
    path: '/box/index_2025',
    name: 'BoxIndex_2025',
    component: patchPage(require('../views/box/index_2025.vue')),
  },
  {
    path: '/box/index_old',
    name: 'BoxIndexOld',
    component: patchPage(require('../views/box/index_old.vue')),
  },
  {
    path: '/box/index',
    name: 'BoxIndex',
    component: patchPage(require('../views/box/index.vue')),
  },
  {
    path: '/box/open_2025',
    name: 'BoxOpen_2025',
    component: patchPage(require('../views/box/open_2025.vue')),
  },
  {
    path: '/box/open_old',
    name: 'BoxOpenOld',
    component: patchPage(require('../views/box/open_old.vue')),
  },
  {
    path: '/box/open_record',
    name: 'BoxOpenRecord',
    component: patchPage(require('../views/box/open_record.vue')),
  },
  {
    path: '/box/open',
    name: 'BoxOpen',
    component: patchPage(require('../views/box/open.vue')),
  },
  {
    path: '/box/order_list',
    name: 'BoxOrderList',
    component: patchPage(require('../views/box/order_list.vue')),
  },
  {
    path: '/box/refund_result',
    name: 'BoxRefundResult',
    component: patchPage(require('../views/box/refund_result.vue')),
  },
  {
    path: '/box/rule_2025',
    name: 'BoxRule_2025',
    component: patchPage(require('../views/box/rule_2025.vue')),
  },
  {
    path: '/box/rule',
    name: 'BoxRule',
    component: patchPage(require('../views/box/rule.vue')),
  },
  {
    path: '/bridge/index',
    name: 'BridgeIndex',
    component: patchPage(require('../views/bridge/index.vue')),
  },
  {
    path: '/bridge/wxpay_callback',
    name: 'BridgeWxpayCallback',
    component: patchPage(require('../views/bridge/wxpay_callback.vue')),
  },
  {
    path: '/bridge/wxpay',
    name: 'BridgeWxpay',
    component: patchPage(require('../views/bridge/wxpay.vue')),
  },
  {
    path: '/cart/index',
    name: 'CartIndex',
    component: patchPage(require('../views/cart/index.vue')),
  },
  {
    path: '/category/index',
    name: 'CategoryIndex',
    component: patchPage(require('../views/category/index.vue')),
  },
  {
    path: '/comment/index',
    name: 'CommentIndex',
    component: patchPage(require('../views/comment/index.vue')),
  },
  {
    path: '/comment/list',
    name: 'CommentList',
    component: patchPage(require('../views/comment/list.vue')),
  },
  {
    path: '/common/reload',
    name: 'CommonReload',
    component: patchPage(require('../views/common/reload.vue')),
  },
  {
    path: '/diy/fixed/qhcs',
    name: 'DiyFixedQhcs',
    component: patchPage(require('../views/diy/fixed/qhcs.vue')),
  },
  {
    path: '/diy/list/index',
    name: 'DiyListIndex',
    component: patchPage(require('../views/diy/list/index.vue')),
  },
  {
    path: '/diy/mart/index',
    name: 'DiyMartIndex',
    component: patchPage(require('../views/diy/mart/index.vue')),
  },
  {
    path: '/diy/page/index',
    name: 'DiyPageIndex',
    component: patchPage(require('../views/diy/page/index.vue')),
  },
  {
    path: '/diy/search/index',
    name: 'DiySearchIndex',
    component: patchPage(require('../views/diy/search/index.vue')),
  },
  {
    path: '/diy/test',
    name: 'DiyTest',
    component: patchPage(require('../views/diy/test.vue')),
  },
  {
    path: '/dky/cart',
    name: 'DkyCart',
    component: patchPage(require('../views/dky/cart.vue')),
  },
  {
    path: '/dky/index',
    name: 'DkyIndex',
    component: patchPage(require('../views/dky/index.vue')),
  },
  {
    path: '/dky/rxbd',
    name: 'DkyRxbd',
    component: patchPage(require('../views/dky/rxbd.vue')),
  },
  {
    path: '/dky/tjsp',
    name: 'DkyTjsp',
    component: patchPage(require('../views/dky/tjsp.vue')),
  },
  {
    path: '/dky/user',
    name: 'DkyUser',
    component: patchPage(require('../views/dky/user.vue')),
  },
  {
    path: '/dky/xsth',
    name: 'DkyXsth',
    component: patchPage(require('../views/dky/xsth.vue')),
  },
  {
    path: '/dky/zxkt',
    name: 'DkyZxkt',
    component: patchPage(require('../views/dky/zxkt.vue')),
  },
  {
    path: '/exchange/index',
    name: 'ExchangeIndex',
    component: patchPage(require('../views/exchange/index.vue')),
  },
  {
    path: '/exchange/info',
    name: 'ExchangeInfo',
    component: patchPage(require('../views/exchange/info.vue')),
  },
  {
    path: '/exchange/store',
    name: 'ExchangeStore',
    component: patchPage(require('../views/exchange/store.vue')),
  },
  {
    path: '/express/index',
    name: 'ExpressIndex',
    component: patchPage(require('../views/express/index.vue')),
  },
  {
    path: '/express/packages',
    name: 'ExpressPackages',
    component: patchPage(require('../views/express/packages.vue')),
  },
  {
    path: '/goods/index',
    name: 'GoodsIndex',
    component: patchPage(require('../views/goods/index.vue')),
  },
  {
    path: '/goods1/index',
    name: 'Goods1Index',
    component: patchPage(require('../views/goods1/index.vue')),
  },
  {
    path: '/group_buying/index',
    name: 'GroupBuyingIndex',
    component: patchPage(require('../views/group_buying/index.vue')),
  },
  {
    path: '/group_buying/invite',
    name: 'GroupBuyingInvite',
    component: patchPage(require('../views/group_buying/invite.vue')),
  },
  {
    path: '/group_buying/order/detail',
    name: 'GroupBuyingOrderDetail',
    component: patchPage(require('../views/group_buying/order/detail.vue')),
  },
  {
    path: '/group_buying/order/index',
    name: 'GroupBuyingOrderIndex',
    component: patchPage(require('../views/group_buying/order/index.vue')),
  },
  {
    path: '/group_buying/pay_success',
    name: 'GroupBuyingPaySuccess',
    component: patchPage(require('../views/group_buying/pay_success.vue')),
  },
  {
    path: '/home/index',
    name: 'HomeIndex',
    component: patchPage(require('../views/home/index.vue')),
  },
  {
    path: '/instant_delivery/goods/index',
    name: 'InstantDeliveryGoodsIndex',
    component: patchPage(require('../views/instant_delivery/goods/index.vue')),
  },
  {
    path: '/instant_delivery/index',
    name: 'InstantDeliveryIndex',
    component: patchPage(require('../views/instant_delivery/index.vue')),
  },
  {
    path: '/instant_delivery/mart/detail',
    name: 'InstantDeliveryMartDetail',
    component: patchPage(require('../views/instant_delivery/mart/detail.vue')),
  },
  {
    path: '/instant_delivery/mart/index',
    name: 'InstantDeliveryMartIndex',
    component: patchPage(require('../views/instant_delivery/mart/index.vue')),
  },
  {
    path: '/instant_delivery/mart/list',
    name: 'InstantDeliveryMartList',
    component: patchPage(require('../views/instant_delivery/mart/list.vue')),
  },
  {
    path: '/instant_delivery/order/detail',
    name: 'InstantDeliveryOrderDetail',
    component: patchPage(require('../views/instant_delivery/order/detail.vue')),
  },
  {
    path: '/instant_delivery/order/index',
    name: 'InstantDeliveryOrderIndex',
    component: patchPage(require('../views/instant_delivery/order/index.vue')),
  },
  {
    path: '/instant_delivery/order/place',
    name: 'InstantDeliveryOrderPlace',
    component: patchPage(require('../views/instant_delivery/order/place.vue')),
  },
  {
    path: '/instant_delivery/order/success',
    name: 'InstantDeliveryOrderSuccess',
    component: patchPage(
      require('../views/instant_delivery/order/success.vue'),
    ),
  },
  {
    path: '/invoice/detail',
    name: 'InvoiceDetail',
    component: patchPage(require('../views/invoice/detail.vue')),
  },
  {
    path: '/invoice/request',
    name: 'InvoiceRequest',
    component: patchPage(require('../views/invoice/request.vue')),
  },
  {
    path: '/joint_std/goods/index',
    name: 'JointStdGoodsIndex',
    component: patchPage(require('../views/joint_std/goods/index.vue')),
  },
  {
    path: '/joint_std/order/cancel_result',
    name: 'JointStdOrderCancelResult',
    component: patchPage(require('../views/joint_std/order/cancel_result.vue')),
  },
  {
    path: '/joint_std/order/comment',
    name: 'JointStdOrderComment',
    component: patchPage(require('../views/joint_std/order/comment.vue')),
  },
  {
    path: '/joint_std/order/confirm_result',
    name: 'JointStdOrderConfirmResult',
    component: patchPage(
      require('../views/joint_std/order/confirm_result.vue'),
    ),
  },
  {
    path: '/joint_std/order/detail',
    name: 'JointStdOrderDetail',
    component: patchPage(require('../views/joint_std/order/detail.vue')),
  },
  {
    path: '/joint_std/order/index',
    name: 'JointStdOrderIndex',
    component: patchPage(require('../views/joint_std/order/index.vue')),
  },
  {
    path: '/joint_std/order/pay_result',
    name: 'JointStdOrderPayResult',
    component: patchPage(require('../views/joint_std/order/pay_result.vue')),
  },
  {
    path: '/joint_std/order/place',
    name: 'JointStdOrderPlace',
    component: patchPage(require('../views/joint_std/order/place.vue')),
  },
  {
    path: '/joint/goods/index',
    name: 'JointGoodsIndex',
    component: patchPage(require('../views/joint/goods/index.vue')),
  },
  {
    path: '/joint/order/place',
    name: 'JointOrderPlace',
    component: patchPage(require('../views/joint/order/place.vue')),
  },
  {
    path: '/joint/order/success',
    name: 'JointOrderSuccess',
    component: patchPage(require('../views/joint/order/success.vue')),
  },
  {
    path: '/manage/afterSales',
    name: 'ManageAfterSales',
    component: patchPage(require('../views/manage/afterSales.vue')),
  },
  {
    path: '/manage/basicset/index',
    name: 'ManageBasicsetIndex',
    component: patchPage(require('../views/manage/basicset/index.vue')),
  },
  {
    path: '/manage/deliveryperson/add',
    name: 'ManageDeliverypersonAdd',
    component: patchPage(require('../views/manage/deliveryperson/add.vue')),
  },
  {
    path: '/manage/deliveryperson/index',
    name: 'ManageDeliverypersonIndex',
    component: patchPage(require('../views/manage/deliveryperson/index.vue')),
  },
  {
    path: '/manage/index',
    name: 'ManageIndex',
    component: patchPage(require('../views/manage/index.vue')),
  },
  {
    path: '/manage/orderdelivery/agreeRefundSheet',
    name: 'ManageOrderdeliveryAgreeRefundSheet',
    component: patchPage(
      require('../views/manage/orderdelivery/agreeRefundSheet.vue'),
    ),
  },
  {
    path: '/manage/orderdelivery/index',
    name: 'ManageOrderdeliveryIndex',
    component: patchPage(require('../views/manage/orderdelivery/index.vue')),
  },
  {
    path: '/manage/orderdelivery/orderDetail',
    name: 'ManageOrderdeliveryOrderDetail',
    component: patchPage(
      require('../views/manage/orderdelivery/orderDetail.vue'),
    ),
  },
  {
    path: '/manage/orderdelivery/orderItem',
    name: 'ManageOrderdeliveryOrderItem',
    component: patchPage(
      require('../views/manage/orderdelivery/orderItem.vue'),
    ),
  },
  {
    path: '/manage/orderItem',
    name: 'ManageOrderItem',
    component: patchPage(require('../views/manage/orderItem.vue')),
  },
  {
    path: '/mart/cert',
    name: 'MartCert',
    component: patchPage(require('../views/mart/cert.vue')),
  },
  {
    path: '/mart/classified_goods',
    name: 'MartClassifiedGoods',
    component: patchPage(require('../views/mart/classified_goods.vue')),
  },
  {
    path: '/mart/index',
    name: 'MartIndex',
    component: patchPage(require('../views/mart/index.vue')),
  },
  {
    path: '/mart/photo',
    name: 'MartPhoto',
    component: patchPage(require('../views/mart/photo.vue')),
  },
  {
    path: '/mart/search',
    name: 'MartSearch',
    component: patchPage(require('../views/mart/search.vue')),
  },
  {
    path: '/order/cancel_result',
    name: 'OrderCancelResult',
    component: patchPage(require('../views/order/cancel_result.vue')),
  },
  {
    path: '/order/center',
    name: 'OrderCenter',
    component: patchPage(require('../views/order/center.vue')),
  },
  {
    path: '/order/change_address',
    name: 'OrderChangeAddress',
    component: patchPage(require('../views/order/change_address.vue')),
  },
  {
    path: '/order/comment',
    name: 'OrderComment',
    component: patchPage(require('../views/order/comment.vue')),
  },
  {
    path: '/order/confirm_result',
    name: 'OrderConfirmResult',
    component: patchPage(require('../views/order/confirm_result.vue')),
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    component: patchPage(require('../views/order/detail.vue')),
  },
  {
    path: '/order/exchange_result',
    name: 'OrderExchangeResult',
    component: patchPage(require('../views/order/exchange_result.vue')),
  },
  {
    path: '/order/index',
    name: 'OrderIndex',
    component: patchPage(require('../views/order/index.vue')),
  },
  {
    path: '/order/pay_error',
    name: 'OrderPayError',
    component: patchPage(require('../views/order/pay_error.vue')),
  },
  {
    path: '/order/pay_result',
    name: 'OrderPayResult',
    component: patchPage(require('../views/order/pay_result.vue')),
  },
  {
    path: '/order/place',
    name: 'OrderPlace',
    component: patchPage(require('../views/order/place.vue')),
  },
  {
    path: '/order/place1',
    name: 'OrderPlace1',
    component: patchPage(require('../views/order/place1.vue')),
  },
  {
    path: '/order/qsxfj_pay_result',
    name: 'OrderQsxfjPayResult',
    component: patchPage(require('../views/order/qsxfj_pay_result.vue')),
  },
  {
    path: '/pay/index',
    name: 'PayIndex',
    component: patchPage(require('../views/pay/index.vue')),
  },
  {
    path: '/safe_keyboard_test/index',
    name: 'SafeKeyboardTestIndex',
    component: patchPage(require('../views/safe_keyboard_test/index.vue')),
  },
  {
    path: '/search/entry',
    name: 'SearchEntry',
    component: patchPage(require('../views/search/entry.vue')),
  },
  {
    path: '/search/index',
    name: 'SearchIndex',
    component: patchPage(require('../views/search/index.vue')),
  },
  {
    path: '/seckill/index',
    name: 'SeckillIndex',
    component: patchPage(require('../views/seckill/index.vue')),
  },
  {
    path: '/slh/category',
    name: 'SlhCategory',
    component: patchPage(require('../views/slh/category.vue')),
  },
  {
    path: '/slh/search',
    name: 'SlhSearch',
    component: patchPage(require('../views/slh/search.vue')),
  },
  {
    path: '/station/pick',
    name: 'StationPick',
    component: patchPage(require('../views/station/pick.vue')),
  },
  {
    path: '/strategy/index',
    name: 'StrategyIndex',
    component: patchPage(require('../views/strategy/index.vue')),
  },
  {
    path: '/template',
    name: 'Template',
    component: patchPage(require('../views/template.vue')),
  },
  {
    path: '/template2',
    name: 'Template2',
    component: patchPage(require('../views/template2.vue')),
  },
  {
    path: '/test/safe',
    name: 'TestSafe',
    component: patchPage(require('../views/test/safe.vue')),
  },
  {
    path: '/topic/index',
    name: 'TopicIndex',
    component: patchPage(require('../views/topic/index.vue')),
  },
  {
    path: '/topic/top',
    name: 'TopicTop',
    component: patchPage(require('../views/topic/top.vue')),
  },
  {
    path: '/travel/comment/add',
    name: 'TravelCommentAdd',
    component: patchPage(require('../views/travel/comment/add.vue')),
  },
  {
    path: '/travel/comment/detail',
    name: 'TravelCommentDetail',
    component: patchPage(require('../views/travel/comment/detail.vue')),
  },
  {
    path: '/travel/comment/index',
    name: 'TravelCommentIndex',
    component: patchPage(require('../views/travel/comment/index.vue')),
  },
  {
    path: '/travel/goods/index',
    name: 'TravelGoodsIndex',
    component: patchPage(require('../views/travel/goods/index.vue')),
  },
  {
    path: '/travel/index',
    name: 'TravelIndex',
    component: patchPage(require('../views/travel/index.vue')),
  },
  {
    path: '/travel/order/detail',
    name: 'TravelOrderDetail',
    component: patchPage(require('../views/travel/order/detail.vue')),
  },
  {
    path: '/travel/order/index',
    name: 'TravelOrderIndex',
    component: patchPage(require('../views/travel/order/index.vue')),
  },
  {
    path: '/travel/order/place',
    name: 'TravelOrderPlace',
    component: patchPage(require('../views/travel/order/place.vue')),
  },
  {
    path: '/travel/order/place1',
    name: 'TravelOrderPlace1',
    component: patchPage(require('../views/travel/order/place1.vue')),
  },
  {
    path: '/travel/refund/request',
    name: 'TravelRefundRequest',
    component: patchPage(require('../views/travel/refund/request.vue')),
  },
  {
    path: '/travel/refund/result',
    name: 'TravelRefundResult',
    component: patchPage(require('../views/travel/refund/result.vue')),
  },
  {
    path: '/travel/verify/confirm',
    name: 'TravelVerifyConfirm',
    component: patchPage(require('../views/travel/verify/confirm.vue')),
  },
  {
    path: '/travel/verify/detail',
    name: 'TravelVerifyDetail',
    component: patchPage(require('../views/travel/verify/detail.vue')),
  },
  {
    path: '/travel/verify/index',
    name: 'TravelVerifyIndex',
    component: patchPage(require('../views/travel/verify/index.vue')),
  },
  {
    path: '/travel/verify/mart',
    name: 'TravelVerifyMart',
    component: patchPage(require('../views/travel/verify/mart.vue')),
  },
  {
    path: '/travel/verify/result',
    name: 'TravelVerifyResult',
    component: patchPage(require('../views/travel/verify/result.vue')),
  },
  {
    path: '/tv/after_sales/request',
    name: 'TvAfterSalesRequest',
    component: patchPage(require('../views/tv/after_sales/request.vue')),
  },
  {
    path: '/tv/book/goods/explain',
    name: 'TvBookGoodsExplain',
    component: patchPage(require('../views/tv/book/goods/explain.vue')),
  },
  {
    path: '/tv/book/goods/index',
    name: 'TvBookGoodsIndex',
    component: patchPage(require('../views/tv/book/goods/index.vue')),
  },
  {
    path: '/tv/book/goods/result',
    name: 'TvBookGoodsResult',
    component: patchPage(require('../views/tv/book/goods/result.vue')),
  },
  {
    path: '/tv/book/index',
    name: 'TvBookIndex',
    component: patchPage(require('../views/tv/book/index.vue')),
  },
  {
    path: '/tv/book/order/detail',
    name: 'TvBookOrderDetail',
    component: patchPage(require('../views/tv/book/order/detail.vue')),
  },
  {
    path: '/tv/book/order/index',
    name: 'TvBookOrderIndex',
    component: patchPage(require('../views/tv/book/order/index.vue')),
  },
  {
    path: '/tv/book/order/result',
    name: 'TvBookOrderResult',
    component: patchPage(require('../views/tv/book/order/result.vue')),
  },
  {
    path: '/tv/cart/index',
    name: 'TvCartIndex',
    component: patchPage(require('../views/tv/cart/index.vue')),
  },
  {
    path: '/tv/goods/index',
    name: 'TvGoodsIndex',
    component: patchPage(require('../views/tv/goods/index.vue')),
  },
  {
    path: '/tv/home/index',
    name: 'TvHomeIndex',
    component: patchPage(require('../views/tv/home/index.vue')),
  },
  {
    path: '/tv/mart/index',
    name: 'TvMartIndex',
    component: patchPage(require('../views/tv/mart/index.vue')),
  },
  {
    path: '/tv/order/detail',
    name: 'TvOrderDetail',
    component: patchPage(require('../views/tv/order/detail.vue')),
  },
  {
    path: '/tv/order/index',
    name: 'TvOrderIndex',
    component: patchPage(require('../views/tv/order/index.vue')),
  },
  {
    path: '/tv/order/place',
    name: 'TvOrderPlace',
    component: patchPage(require('../views/tv/order/place.vue')),
  },
  {
    path: '/tv/search/index',
    name: 'TvSearchIndex',
    component: patchPage(require('../views/tv/search/index.vue')),
  },
  {
    path: '/tv/seckill/index',
    name: 'TvSeckillIndex',
    component: patchPage(require('../views/tv/seckill/index.vue')),
  },
  {
    path: '/tv/template_class',
    name: 'TvTemplateClass',
    component: patchPage(require('../views/tv/template_class.vue')),
  },
  {
    path: '/tv/template',
    name: 'TvTemplate',
    component: patchPage(require('../views/tv/template.vue')),
  },
  {
    path: '/tv/topic/index',
    name: 'TvTopicIndex',
    component: patchPage(require('../views/tv/topic/index.vue')),
  },
  {
    path: '/tv/user/favorite',
    name: 'TvUserFavorite',
    component: patchPage(require('../views/tv/user/favorite.vue')),
  },
  {
    path: '/user/comment',
    name: 'UserComment',
    component: patchPage(require('../views/user/comment.vue')),
  },
  {
    path: '/user/favorite',
    name: 'UserFavorite',
    component: patchPage(require('../views/user/favorite.vue')),
  },
  {
    path: '/user/history',
    name: 'UserHistory',
    component: patchPage(require('../views/user/history.vue')),
  },
  {
    path: '/user/index',
    name: 'UserIndex',
    component: patchPage(require('../views/user/index.vue')),
  },
  {
    path: '/user/protocol',
    name: 'UserProtocol',
    component: patchPage(require('../views/user/protocol.vue')),
  },
  // @endindex
]

routes.forEach(route => {
  // 兼容 /view 开头的以 - 分隔的路由
  route.alias = [`/view${route.path.replace(/_/g, '-')}`]

  // 兼容电商中台标准路由
  switch (route.name) {
    // 首页
    case pageNameMap.HomeIndex:
      route.alias.push('/', '/view/home')
      break
    // 商品详情
    case pageNameMap.GoodsIndex:
      route.alias.push('/commodity/index')
      route.alias.push('/view/commodity/index')
      route.alias.push('/view/commodity/detail')
      break
    // 订单列表
    case pageNameMap.OrderIndex:
      route.alias.push('/view/user/order/list', '/view/order/list')
      break
    // 订单详情
    case pageNameMap.OrderDetail:
      route.alias.push('/view/user/order/detail')
      break
    // 店铺首页
    case pageNameMap.MartIndex:
      route.alias.push('/view/mart/detail')
      break
    case pageNameMap.TopicIndex:
      route.alias.push('/special/index', '/view/special/index')
      break
    default:
      break
  }

  if (route.path.endsWith('/index')) {
    route.alias!.push(route.path.replace(/\/index$/, ''))
  }

  if (route.path.endsWith('/_layout')) {
    const prefix = route.path.replace(/\/_layout$/, '')
    route.children = routes.filter(
      item =>
        item.path !== route.path &&
        item.path.replace(/\/[^/]+$/, '') === prefix,
    )
    route.children.forEach(route => {
      // @ts-ignore
      route.__is_children__ = true
    })
  }
})
routes = routes.filter(
  route =>
    // @ts-ignore
    !route.__is_children__,
)

export const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition) {
      return savedPosition
    }
    // 不处理弹窗式路由
    if (!/_n\d+_=1/.test(to.fullPath)) {
      // 异步滚动操作
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            x: 0,
            y: 0,
          })
        }, 0)
      })
    }
  },
})

// 既存的各种订单列表统一跳往新版订单中心兼容处理
router.beforeEach((to, from, next) => {
  // 标销订单列表: 根据原 active 参数决定
  if (to.name === pageNameMap.OrderIndex) {
    next({
      name: pageNameMap.OrderCenter,
      query: {
        type: String(
          {
            // 全部
            0: 0,
            // 待付款
            1: 1,
            // 待发货
            2: 2,
            // 待收货
            3: 3,
            // 待使用
            6: 6,
            // 待评价
            4: 0,
            // 退款/售后
            5: 10,
          }[+to.query.active] ?? 0,
        ),
      },
    })
  }
  // 拼团订单列表: 跳拼团 tab
  else if (to.name === pageNameMap.GroupBuyingOrderIndex) {
    next({
      name: pageNameMap.OrderCenter,
      query: {
        type: '12',
      },
    })
  }
  // 盲盒订单列表: 跳盲盒 tab
  else if (to.name === pageNameMap.BoxOrderList) {
    next({
      name: pageNameMap.OrderCenter,
      query: {
        type: '11',
      },
    })
  }
  // 配送订单列表/标销订单列表: 直接跳全部 tab
  else if (
    to.name === pageNameMap.InstantDeliveryOrderIndex ||
    to.name === pageNameMap.BookOrderIndex
  ) {
    next({
      name: pageNameMap.OrderCenter,
      query: {
        type: '0',
      },
    })
  }
  // 非订单列表页，不予处理
  else {
    next()
  }
})

export type PageName = keyof typeof pageNameMap

export function navigateTo(pageName: PageName, query?: Record<string, any>) {
  if (globalModel.state.isEmbed) {
    const url = `${location.href.split('#')[0]}#${
      pagePathMap[pageName]
    }?${createUrlQueryString({
      ...query,
      isFull: true,
      isAuth: true,
      isLogin: true,
    })}`
    dcb.navigateTo({
      url: url,
    })
    return
  }

  router.push({
    name: pageName,
    query: mapValues(query, value => (value == null ? value : String(value))),
  })
}

export function redirectTo(pageName: PageName, query?: Record<string, any>) {
  router.replace({
    name: pageName,
    query: mapValues(query, String),
  })
}

export function navigateBack(delta = 1) {
  // NOTE: 勿用 history.length 判断是否可回退
  // https://zhuanlan.zhihu.com/p/91931664
  const currentUrl = location.href
  router.go(-delta)
  setTimeout(() => {
    if (location.href === currentUrl) {
      if (dcb.getEnvSync().dcb) {
        dcb.navigateBack()

        setTimeout(() => {
          if (location.href === currentUrl) {
            if (dcb.getEnvSync().dcb) {
              if ((window as any).__dcb_before_close__) {
                ;(window as any).__dcb_before_close__(() => dcb.closeWindow())
              } else {
                dcb.closeWindow()
              }
            }
          }
        }, 60)
      } else {
        dcb.closeWindow()
        wechat.closeWindow()
      }
    }
  }, 60)
}

export function navigateBackOrTo(
  pageName: PageName,
  query?: Record<string, any>,
) {
  if (prevPageIs(pageName)) {
    navigateBack()
  } else {
    navigateTo(pageName, query)
  }
}

export function prevPageIs(pageName: PageName) {
  const routes: string[] = Vue.prototype.$navigation.getRoutes()
  return routes[routes.length - 2]?.startsWith(pageName)
}

export function getPageUrl(
  pageName: PageName,
  query?: Record<string, any>,
  envOrOptions:
    | 'current'
    | 'test'
    | 'prod'
    | {
        env?: 'current' | 'test' | 'prod'
        user?: string
        channelId?: string
        noDefaultChannelId?: boolean
      } = 'current',
): string {
  const isTv = pageName.indexOf('Tv') === 0
  const env =
    (typeof envOrOptions === 'string' ? envOrOptions : envOrOptions.env) ||
    'current'
  const user = (typeof envOrOptions === 'string' ? '' : envOrOptions.user) || ''
  const channelId =
    (typeof envOrOptions === 'string' ? '' : envOrOptions.channelId) ||
    (typeof envOrOptions === 'string'
      ? currentChannelId
      : envOrOptions.noDefaultChannelId
      ? ''
      : currentChannelId)
  const baseUrl =
    env === 'test'
      ? isTv
        ? 'https://tv-h5.duotest.cn/app/duoduo-mall/'
        : 'https://h5.gogpay.cn/h5-test/app/duoduo-mall/'
      : env === 'prod'
      ? isTv
        ? 'https://tv-h5.gogpay.cn/duoduo-mall/'
        : 'https://h5.gogpay.cn/h5/app/duoduo-mall/'
      : location.href.split('#')[0]
  return `${baseUrl}#${pagePathMap[pageName]}?${createUrlQueryString({
    isFull: true,
    isLogin: true,
    isAuth: true,
    ...(user ? { fromUser: user } : {}),
    ...(globalModel.state.isTV ? { fromTV: globalModel.state.isTV } : {}),
    ...(channelId ? { refUserGroupId: channelId } : {}),
    ...(query || {}),
  })}`
}

export function getCurrentPageUrl() {
  return getPageUrl(router.currentRoute.name as any, router.currentRoute.query)
}

export function reloadPage() {
  redirectTo('CommonReload', {
    pageName: router.currentRoute.name,
    pageQuery: JSON.stringify(router.currentRoute.query),
  })
}

Vue.use(Navigation, { router, keyName: 'rf' })
